<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('add')}} {{ $tc('role', 1) }} {{ $t('access') }}</div>
      <router-link class="btn-blue" to="role-access">{{ $tc('role', 1) }} {{ $tc('list')}}</router-link>
    </div>

    <div class="white-wrapper">
      <div class="row">
        <div class="col-md-6 mb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label
                :class="selectedRole.label.length > 0 ? 'shift-up' : ''"
              >{{$t('select') }} {{$tc('role', 1)}}</label>
              <b-dropdown :text="selectedRole.label" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(role , rolekey) in Roles"
                  :key="rolekey"
                  @click="onSelectHandler('role',role)"
                >{{role.role_name}}</b-dropdown-item>
              </b-dropdown>
            </div>

            <Tooltip :title="$t('moviesearch')" />
          </div>
          <p
            v-if="submitted && selectedRole.label.length == 0"
            class="error_message"
          >Please Select Role.</p>
        </div>

        <div class="col-md-6 mb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label
                :class="selectedModule.label.length > 0 ? 'shift-up' : ''"
              >{{$t('select') }} {{$tc('module', 1)}}</label>
              <b-dropdown :text="selectedModule.label" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(moduleItem , modulekey) in Modules"
                  :key="modulekey"
                  v-on:click="onSelectHandler('moduleItem',moduleItem)"
                >{{moduleItem.module_name}}</b-dropdown-item>
              </b-dropdown>
            </div>

            <Tooltip :title="$t('moviesearch')" />
          </div>
          <p
            v-if="submitted && selectedModule.label.length == 0"
            class="error_message"
          >Please Select Module.</p>
        </div>

        <div class="col-md-6"></div>
        <div class="col-md-12">
          <div class="row">
            <div v-for="(feature,featureKey) in Features" :key="featureKey" class="col-md-3">
              <div class="custom-control custom-checkbox my-1 mr-sm-2">
                <input
                  v-on:click="onSelectHandler('feature',feature)"
                  type="checkbox"
                  class="custom-control-input"
                  :id="'customControlInline'+featureKey"
                />
                <label
                  class="custom-control-label"
                  :for="'customControlInline'+featureKey"
                >{{ feature.feature_name }}</label>
              </div>
            </div>
            <!-- <div class="col-md-3">
              <div class="custom-control custom-checkbox my-1 mr-sm-2">
                <input type="checkbox" class="custom-control-input" id="customControlInline2" />
                <label
                  class="custom-control-label"
                  for="customControlInline2"
                >{{ $tc('feature', 1) }} 2</label>
              </div>
            </div>
            <div class="col-md-3">
              <div class="custom-control custom-checkbox my-1 mr-sm-2">
                <input type="checkbox" class="custom-control-input" id="customControlInline3" />
                <label
                  class="custom-control-label"
                  for="customControlInline3"
                >{{ $tc('feature', 1) }} 3</label>
              </div>
            </div>
            <div class="col-md-3">
              <div class="custom-control custom-checkbox my-1 mr-sm-2">
                <input type="checkbox" class="custom-control-input" id="customControlInline4" />
                <label
                  class="custom-control-label"
                  for="customControlInline4"
                >{{ $tc('feature', 1) }} 4</label>
              </div>
            </div>-->
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            @click.prevent.stop="onAddFeature(false)"
            class="btn-blue"
          >{{ $t('save')}} & {{ $t('add')}} {{ $t('more')}}</button>
          <button @click.prevent.stop="onAddFeature(true)" class="btn-blue">{{ $t('save')}}</button>
          <button class="btn-black">{{ $t('reset')}}</button>
          <b-button class="btn-outline-grey" variant="default" to="role-access">{{ $t('cancel')}}</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import UserPermission from "@/services/UserPermission";

export default {
  data() {
    return {
      submitted: false,
      selectedRole: {
        label: "",
        value: ""
      },
      Roles: [],
      RolesMethod: {
        GET: "/admin/",
        tableName: "ms_roles",
        urlKey: "roles"
      },
      selectedModule: {
        label: "",
        value: ""
      },
      Modules: [],
      ModulesMethod: {
        GET: "/admin/",
        tableName: "ms_modules",
        urlKey: "modules"
      },
      Features: [],
      selectedFeatures: [],
      FeaturesMethod: {
        GET: "/admin/tablelist/",
        tableName: "ms_features",
        urlKey: "features"
      }
    };
  },
  beforeMount() {
    this.getRolesList();
    this.getModulesList();
  },
  methods: {
    onSelectHandler: function(type, value) {
      if (type == "role") {
        this.selectedRole.label = value.role_name;
        this.selectedRole.value = value.role_id;
      } else if (type == "moduleItem") {
        this.selectedModule.label = value.module_name;
        this.selectedModule.value = value.module_id;
        this.getFeaturesList(value.module_id);
      } else if (type == "feature") {
        let index = this.selectedFeatures.indexOf(value.feature_id);
        if (index > -1) {
          this.selectedFeatures.splice(index, 1);
        } else {
          this.selectedFeatures.push(value.feature_id);
        }
      }
    },
    getRolesList: function() {
      this.Roles = [];
      let body = this.getRequestBody("GET", undefined, this.RolesMethod);
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Roles = data.Records;
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    getModulesList: function() {
      this.Modules = [];
      let body = this.getRequestBody("GET", undefined, this.ModulesMethod);
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Modules = data.Records;
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    getFeaturesList: function(module_id) {
      this.Features = [];
      let body = this.getRequestBody("GET", undefined, {
        ...this.FeaturesMethod,
        params: { id: "module_id-" + module_id }
      });
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Features = data.Records;
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    onAddFeature: function() {
      this.submitted = true;
      let payload = {
        role_id: this.selectedRole.value,
        feature_id: this.selectedFeatures.toString(),
        rf_is_active: "Y"
      };
      UserPermission.CreateRole(payload)
        .then(response => {
          const { data } = response;
          console.log("data :", data);
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Pages/RoleManagementContainer/RoleAccessComponents/addRoleAccess.vue